export const state = () => ({
  isLoading: false,
  serviceReplayOverview: [],
  serviceReplay: [],
})

export const mutations = {
  setIsLoading (state, isLoading) {
    state.isLoading = isLoading
  },
  setServiceReplayOverview (state, serviceReplayOverview) {
    state.serviceReplayOverview = serviceReplayOverview
  },
  setServiceReplay (state, serviceReplay) {
    state.serviceReplay = serviceReplay
  },
}

export const actions = {
  async fetchServiceReplayOverview ({ state, commit }) {
    if (state.serviceReplayOverview.length) return
    try {
      commit('setIsLoading', true)
      const response = await this.$axios.$get('/cms/service-replay/overview')
      commit('setServiceReplayOverview', response)
      commit('setIsLoading', false)
    } catch (error) {
      console.error(error.stack)
      commit('setIsLoading', false)
    }
  },

  async fetchServiceReplayById ({ state, commit }, id) {
    if (state.serviceReplay.length) return
    try {
      commit('setIsLoading', true)
      const resource = await this.$axios.$get(`/cms/service-replay/${id}`)
      commit('setServiceReplay', resource)
      commit('setIsLoading', false)
    } catch (error) {
      console.error(error.stack)
      commit('setIsLoading', false)
      if (error.response.status === 403) {
        this.$router.push({ path: '/' })
      }
    }
  },
}
